module.exports = __webpack_public_path__ + "img/bombEffect1.62412085.svg";